import { reAssignExpensePositions, createFinancialsSortedExpensesPointer } from "../../shared/FinancialViewHelpers";

export const expensePointers = agent =>   {
  reAssignExpensePositions(agent)    
  return createFinancialsSortedExpensesPointer(agent);
}
